module.exports = __webpack_public_path__ + "img/69c713e.webp";